<template>
  <div class="warn-index">
    <div class="warn-top">
      <div class="input-date-wrapper">
        <el-date-picker
          v-model="value"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="input-wrapper">
        <input v-model="keyword" placeholder="请输入关键字"/>
      </div>
      <div style="margin-right: 1vw">
        <DropDown content="请选择传感器类型" :items="nodeTypeData" v-on:sendInfo = "showInfo"></DropDown>
      </div>
	  <div style="margin-right: 1vw">
	    <DropDown content="请选择处理结果" :items="isDealData" v-on:sendInfo = "showInfo2"></DropDown>
	  </div>
      <div class="query" @click="handleSearch(1)">查询</div>
    </div>
    <div class="warn-bottom">
      <div class="warn-bottom-handle">
        <div class="warn-bottom-handle-left">
<!--          <div class="four-font-wrapper handle" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>-->
          <div class="fif-font-wrapper handle" @click="toHistoryWarn"><div class="icon-font">&#xe600;</div>历史预警单</div>
          <div class="four-font-wrapper handle" @click="toStatisticalWarn"><div class="icon-font">&#xe65b;</div>预警统计</div>
          <div class="four-font-wrapper handle" @click="toSetWarn"><div class="icon-font">&#xe608;</div>预警值设置</div>
          <div class="six-font-wrapper" @click="setRemind"><div class="icon-font">&#xe608;</div>{{remind === 1 ? '关闭短息提醒' : '开启短信提醒'}}</div>
        </div>
        <div class="warn-bottom-handle-right">
          预警次数：{{total}}次
        </div>
      </div>
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
<!--            <div class="warn-item" style="width: 5%">-->
<!--              <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>-->
<!--            </div>-->
            <div class="detail-item" style="width: 5%">序号</div>
            <div class="detail-item" style="width: 8%">探针ID</div>
            <div class="detail-item" style="width: 9%">传感器类型</div>
			 <div class="detail-item" style="width: 5%">上限值</div>
            <div class="detail-item" style="width: 5%">数值</div>
			 <div class="detail-item" style="width: 5%">下限值</div>
            <div class="detail-item" style="width: 8%">负责人</div>
            <div class="detail-item" style="width: 15%">位置</div>
			 <div class="detail-item" style="width: 10%">养护阶段</div>
            <div class="detail-item" style="width: 14%">时间</div>
            <div class="detail-item" style="width: 8%">是否处理</div>
            <div class="detail-item" style="width: 8%">操作</div>
          </div>
          <div class="detail-content">
            <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
<!--              <div class="warn-item" style="width: 5%">-->
<!--                <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>-->
<!--              </div>-->
              <div class="detail-item" style="width: 5%">{{index+1}}</div>
              <div class="detail-item" style="width: 8%">{{data.nodeId}}</div>
              <div class="detail-item" style="width: 9%">{{getNodeType(data.nodeType)}}</div>
			    <div class="detail-item" style="width: 5%">{{data.earlyValUpper}}</div>
              <div class="detail-item" style="width: 5%">{{data.val}}</div>
			  <div class="detail-item" style="width: 5%">{{data.earlyValLower}}</div>
              <div class="detail-item" style="width: 8%">{{data.principalName}}</div>
              <div class="detail-item" style="width: 15%">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.siteName">
                  <div class="popover" style="width: 12vw;text-align: center" slot="reference">{{data.siteName}}</div>
                </el-popover>
              </div>
			   <div class="detail-item" style="width: 10%">{{getStageType(data.maintainStage)}}</div>
              <div class="detail-item" style="width: 14%">{{getTime(data.createdTime)}}</div>
              <div class="detail-item" style="width: 8%" v-if="data.isDeal==false">
                <div style="padding: 0.2vw 1vw" class="detail-btn item-apply">否</div>
              </div>
			  <div class="detail-item" style="width: 8%" v-else>
			    <div style="padding: 0.2vw 1vw" class="detail-btn item-apply">是</div>
			  </div>
            <div class="detail-item" style="width: 8%">
            	<div class="detail-btn item-look" @click="todueLook(data)">查看</div>
            </div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > rows">
            <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div class="alert-box" v-if="show">
            <div class="alert-content">
              <div class="alert-content-title">删除提醒</div>
              <div class="alert-content-msg">是否确认删除选中数据?</div>
              <div class="alert-content-btn">
                <div class="btn-cancel button" @click="cancelDelete">取消</div>
                <div class="btn-confirm button" @click="confirmDelete">确认</div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="alert-box" v-if="showRemind">
            <div class="alert-content">
              <div class="alert-content-title">{{remind === 1 ? '关闭' : '开启'}}提醒</div>
              <div class="alert-content-msg">是否{{remind === 1 ? '关闭' : '开启'}}提醒?</div>
              <div class="alert-content-btn">
                <div class="btn-cancel button" @click="cancelRemind">取消</div>
                <div class="btn-confirm button" @click="confirmRemind">确认</div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import { queryEarlyWarning, searchEventFlag, updateEventFlag } from '../../../api/maintain'
import { renderTime } from '../../../tools/methods'
export default {
  name: 'WarnIndex',
  components: { DropDown },
  data () {
    return {
      value: '',
      nodeTypeData: [
        {name: '全部', value: ''},
        {name: '无线氧气传感器', value: '01'},
        {name: '无线二氧化碳传感器', value: '02'},
        {name: '无线温湿度传感器', value: '03'},
        {name: '无线包芯温度传感器', value: '04'},
        {name: '无线包芯水分传感器', value: '05'}
      ],
	  isDealData: [
	    {name: '全部', value: ''},
	    {name: '已处理', value: '1'},
	    {name: '未处理', value: '0'},
	  ],
	  isDeal:'',
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      loading: true,
      keyword: '',
      nodeType: '',
      startTime: '',
      endTime: '',
      page: 1,
      rows: 9,
      total: '',
      tableData: [],
      remind: 0,
      showRemind: false
    }
  },
  created () {
    this.handleSearch(1)
    searchEventFlag().then(res => {
      console.log('查询短信推送状态')
      console.log(res)
      this.remind = res.data
    }).catch(err => {
      console.log(err)
    })
  },
  watch: {
    value: function () {
      console.log(this.value)
      this.startTime = this.value !== null ? this.value[0] : ''
      this.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  methods: {
	  // 查看功能
	  todueLook: function(id) {
		  console.log(id)
	  	this.$router.push({
	  		path: '/warn/detailYu',
	  		query: {
	  			index: '7',
	  			id: id.siteId,
				nodeId:id.nodeId,
				nodeType:id.nodeType,
				warningHandlingOpinions:id.warningHandlingOpinions,
				createdtime:this.getTime(id.createdTime)	
	  		}
	  	})
	  },
    getTime: function (time) {
      return renderTime(time)
    },
    getNodeType: function (maintainStage) {
      if (maintainStage === '01') {
        return '无线氧气传感器'
      } else if (maintainStage === '02') {
        return '无线二氧化碳传感器'
      } else if (maintainStage === '03') {
        return '无线温湿度传感器'
      } else if (maintainStage === '04') {
        return '无线包芯温度传感器'
      } else if (maintainStage === '05') {
        return '无线包芯水分传感器'
      }
    },
	getStageType: function (addd) {
	  if (addd === '01') {
	    return '自然醇化阶段'
	  } else if (addd === '02') {
	    return '防霉杀虫阶段'
	  } else if (addd === '03') {
	    return '气调醇化阶段'
	  } else if (addd === '04') {
	    return '气调保质阶段'
	  } 
	},
    handleSearch: function (type) {
      if (type === 1) {
        this.page = 1
      }
      let body = {
        page: this.page,
        rows: this.rows,
        keyword: this.keyword,
        nodeType: this.nodeType,
        startTime: this.startTime,
        endTime: this.endTime,
		isDeal:this.isDeal,
      }
      this.loading = true
      queryEarlyWarning(body).then(res => {
        console.log(res)
        res.data.rows && res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows || []
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    toHistoryWarn: function () {
      this.$router.push({
        path: '/warn/historyWarn',
        query: {
          index: '7'
        }
      })
    },
    toSetWarn: function () {
      this.$router.push({
        path: '/warn/setWarn',
        query: {
          index: '7'
        }
      })
    },
    toStatisticalWarn: function () {
      this.$router.push({
        path: '/warn/statisticalWarn',
        query: {
          index: '7'
        }
      })
    },
    showInfo: function (data) {
      console.log(data)
      this.nodeType = data.value
    },
	showInfo2: function (data) {
	  console.log(data)
	  this.isDeal = data.value
	},
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        console.log(this.id)
      } else {
        console.log(this.idList)
      }
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    },
    setRemind: function () {
      this.showRemind = true
    },
    cancelRemind: function () {
      this.showRemind = false
    },
    confirmRemind: function () {
      console.log(this.remind)
      updateEventFlag({flag: this.remind === 0 ? 1 : 0}).then(res => {
        console.log(res)
        this.remind = this.remind === 0 ? 1 : 0
        this.showRemind = false
        this.$message({
          message: '设置成功!',
          type: 'success',
          center: 'true',
          duration: '1000'
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
@import "Warn.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warn/WarnIndex.vue